module.exports = __webpack_public_path__ + "static/media/points10_6.5e38e945.png";